import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';

import { InvoicesService } from '../../../../../_services/invoices.service';
import { CustomerService } from '../../../../../_services';

import { Account, Invoice } from '../../../../../_models';

@Component({
  selector: 'app-accordioninvoicecreate',
  templateUrl: './accordioninvoicecreate.component.html',
  styleUrls: ['./accordioninvoicecreate.component.css']
})
export class AccordioninvoicecreateComponent implements OnInit, AfterViewInit, OnChanges {

  kashioApplication: string;
  // Variable indicating that it will be of type FormGroup
  public invoiceForm: FormGroup;

  // Variable indicating that it will be the invoice public key and will allow access to the invoice information 
  // in case it is duplicated and not created
  @Input() invoicePublic_key: null | string;

  // Through this input I will PULL from the main component the 
  // cusAccountPublicKey_temp to render it through the HTML in the select options
  @Input() cusAccountPublicKey_temp: Account[] = [];
  @Input() currencySymbol: undefined | string;
  @Input() customerPublicIdInput: string;

  @Input() isDueDatetime: boolean;

  // By means of this Output I will TAKE from this component to the main component
  // the form with every change that occurs inside
  // FormGroup typing
  @Output() formData = new EventEmitter<FormGroup>()



  // I initialize the services I am going to use
  constructor(
    private _fb: FormBuilder,
    private invoicesService: InvoicesService,
    private route: ActivatedRoute,
    private customerService: CustomerService
  ) {
    this.InitialSetup();
  }

  setForm() {
    this.invoiceForm.valueChanges.subscribe({
      next: data => {
        this.formData.emit(data);
      }
    });
  }

  ngOnInit() {
    this.kashioApplication = localStorage.getItem('application');

    this.customerService.getCustomerAccountList(this.customerPublicIdInput).subscribe(data => {
      this.cusAccountPublicKey_temp = data;
      if(this.kashioApplication === "PAYOUTS"){
        this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type === 'PAYABLE'));
      } else {
        this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type === 'COLLECT' || t.type === 'RECEIVABLE'));
      }

      if (this.cusAccountPublicKey_temp != undefined && this.cusAccountPublicKey_temp != null) {
        const cusAccountPublicKey_tempLength = this.cusAccountPublicKey_temp.length;
        //If the account is bi-currency, the select value of the total field will be set to "Seleccione".
        cusAccountPublicKey_tempLength > 1 ? "" : setCurrency(this.invoiceForm, this.cusAccountPublicKey_temp[0].balance.currency);
      }

    });

    function setCurrency(form: FormGroup, parameter: string) {
      form.get('late_fee.currency').setValue(parameter);
      form.get('fees.currency').setValue(parameter);
    }

    this.setInvoiceDetails();
  }

  // After the view is rendered, I set up the change listener.
  ngAfterViewInit() {
    this.setForm()
  }

  ngOnChanges() {
    if (this.currencySymbol !== undefined) {
      this.invoiceForm.get('late_fee.currency').setValue(this.currencySymbol);
      this.invoiceForm.get('fees.currency').setValue(this.currencySymbol);
    };

    if (this.isDueDatetime === true) {
      this.invoiceForm.get('late_fee.value').setValue(0);
    };
  };

  InitialSetup() {
    this.invoiceForm = this._fb.group({
      late_fee: this._fb.group({
        currency: new FormControl("Seleccione"),
        value: new FormControl(0)
      }),
      fees: this._fb.group({
        currency: new FormControl("Seleccione"),
        value: new FormControl(0)
      })
    })
  };

  setInvoiceDetails() {
    if (this.invoicePublic_key != null && this.invoicePublic_key != 'invoice Key') {
      this.invoicesService.getInvoice(this.invoicePublic_key).subscribe({
        next: (invoice: Invoice) => {

          // I set the values of the form with the response from the observable
          this.invoiceForm = this._fb.group({
            late_fee: this._fb.group({
              currency: new FormControl(invoice.late_fee.currency),
              value: new FormControl(invoice.late_fee.value)
            }),
            fees: this._fb.group({
              currency: new FormControl(invoice.fees.currency),
              value: new FormControl(invoice.fees.value)
            })
          })
        },
        complete: () => {
          this.setForm();
        }
      })
    }
  };

}
